<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!permissaoDetalhar">
            <div style="text-align: center">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="permissaoDetalhar">
            <form>
                <div class="formgroup">
                    <div class="flex justify-content-center mt-3" *ngIf="loadingServico">
                        <p-progressSpinner></p-progressSpinner>
                    </div>
                    <div *ngIf="messagemVisivel" class="w-auto mb-5">
                        <p-messages
                            [(value)]="messages"
                            [enableService]="false"
                            [closable]="true"
                        ></p-messages>
                    </div>
                    <div class="p-fluid p-formgrid grid" *ngIf="itemServico && !loadingServico">
                        <div class="col-12">
                            <div class="flex justify-content-end">
                                <button
                                    pButton
                                    pRipple
                                    label="Precificar"
                                    pTooltip="Calcular precificação"
                                    tooltipPosition="left"
                                    (click)="abrirDialogValorSugerido()"
                                    icon="pi pi-percentage"
                                    class="p-button-outlined w-full sm:w-12rem"
                                ></button>
                            </div>
                        </div>
                        <div class="col-12 pt-5 px-5">
                            <div class="grid card-simple">
                                <div class="col-12 md:col-4">
                                    <label class="label-superior">Descrição</label>
                                    <label class="label-inferior" id="descricao">
                                        {{ itemServico.descricao }}
                                    </label>
                                </div>

                                <div class="col-12 md:col-4">
                                    <label class="label-superior">Grupo</label>
                                    <label class="label-inferior" id="subgrupo">
                                        {{ itemServico.subgrupo?.grupo?.descricao }} -
                                        {{ itemServico.subgrupo?.descricao }}
                                    </label>
                                </div>

                                <div class="col-12 md:col-2">
                                    <label class="label-superior">Código</label>
                                    <label class="label-inferior" id="codigo">
                                        {{ itemServico.codigo }}
                                    </label>
                                </div>
                                <div class="col-12 md:col-2">
                                    <label class="label-superior">Custo Material</label>
                                    <label class="label-inferior" id="custoMaterial">
                                        {{ itemServico.custoMaterial | porcentagemFormat }}
                                    </label>
                                </div>

                                <div class="col-12 md:col-2">
                                    <label class="label-superior">Comissão</label>
                                    <label class="label-inferior" id="comissao">
                                        {{ itemServico.comissaoVenda | porcentagemFormat }}
                                    </label>
                                </div>

                                <div class="col-12 md:col-2">
                                    <label class="label-superior">Valor Médio</label>
                                    <label class="label-inferior" id="valorMedio">
                                        R$ {{ itemServico.valorVenda?.toFixed(2) }}
                                    </label>
                                </div>

                                <div class="col-12 md:col-2">
                                    <label class="label-superior">Tempo Médio</label>
                                    <label class="label-inferior" id="tempoMedio">
                                        {{ itemServico.tempoMedio }}
                                    </label>
                                </div>

                                <div class="col-12 md:col-2">
                                    <label class="label-superior">Tributável?</label>
                                    <div class="label-inferior">
                                        <label
                                            class="product-badge status-instock"
                                            id="tributacao"
                                            *ngIf="itemServico.tributacao"
                                        >
                                            SIM
                                        </label>
                                        <label
                                            class="product-badge status-outofstock"
                                            id="tributacao"
                                            *ngIf="!itemServico.tributacao"
                                        >
                                            NÃO
                                        </label>
                                    </div>
                                </div>

                                <div class="col-12 md:col-1">
                                    <label class="label-superior">Ativo?</label>
                                    <div class="label-inferior">
                                        <label
                                            class="product-badge status-instock"
                                            id="ativo"
                                            *ngIf="itemServico.ativo"
                                        >
                                            SIM
                                        </label>
                                        <label
                                            class="product-badge status-outofstock"
                                            id="ativo"
                                            *ngIf="!itemServico.ativo"
                                        >
                                            NÃO
                                        </label>
                                    </div>
                                </div>
                                <div class="col-12 md:col-2">
                                    <label class="label-superior">Agenda?</label>
                                    <div class="label-inferior">
                                        <label class="product-badge status-instock" id="agenda">
                                            {{ itemServico.agenda }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 md:col-12">
                            <h5>Custo Material do Serviço</h5>
                        </div>
                        <div class="w-full px-3 mb-5">
                            <p-table
                                #tabelaListaCusto
                                [value]="listaItensCustoAdicionados"
                                dataKey="id"
                                [rows]="10"
                                [rowHover]="true"
                                styleClass="p-datatable-gridlines"
                                [paginator]="false"
                                responsiveLayout="scroll"
                                styleClass=" p-datatable-sm"
                            >
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>
                                            <div>Código</div>
                                        </th>
                                        <th>
                                            <div>Descrição</div>
                                        </th>
                                        <th>
                                            <div>Quantidade UN Medida</div>
                                        </th>

                                        <th>
                                            <div>Quantidade Utilizada</div>
                                        </th>
                                        <th>
                                            <div>Valor de Custo</div>
                                        </th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-item let-i="rowIndex">
                                    <tr>
                                        <td>
                                            <label>{{ item.itemProduto.codigo }}</label>
                                        </td>
                                        <td>
                                            <label>{{ item.itemProduto.descricao }}</label>
                                        </td>
                                        <td>
                                            <label>{{ item.quantidadeUnidadeMedida }}</label>
                                        </td>
                                        <td>
                                            <label>{{ item.quantidade }}</label>
                                        </td>
                                        <td>
                                            <label>
                                                {{
                                                    (item.itemProduto.valorCompra /
                                                        item.quantidadeUnidadeMedida) *
                                                        item.quantidade | currency: "BRL"
                                                }}
                                            </label>
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="summary">
                                    <div class="flex align-items-center justify-content-between">
                                        <div>
                                            Há
                                            {{
                                                listaItensCustoAdicionados
                                                    ? listaItensCustoAdicionados.length
                                                    : 0
                                            }}
                                            produtos inseridos no custo.
                                        </div>
                                        <div>
                                            Total: {{ valorTotalCustoMaterial | currency: "BRL" }}
                                        </div>
                                    </div>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="7">Nenhum registro cadastrado.</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>

                    <div
                        class="p-fluid p-formgrid grid justify-content-end"
                        *ngIf="!loadingServico"
                    >
                        <div class="col-12 md:col-4 flex justify-content-end">
                            <button
                                type="button"
                                pButton
                                icon="pi pi-arrow-left"
                                label="Voltar"
                                class="p-button-outlined md:w-9rem"
                                routerLink="/apps/item-servico"
                            ></button>
                        </div>
                    </div>
                </div>
            </form>
            <p-dialog
                [(visible)]="exibirDialogValorSugerido"
                [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
                [style]="{ width: '35vw' }"
                [header]="'Sugestão de preço - ' + itemServico?.descricao"
                [modal]="true"
                [draggable]="false"
                [resizable]="false"
                class="p-fluid"
            >
                <ng-template pTemplate="content">
                    <div class="flex justify-content-center" *ngIf="loadingSpinnerDialog">
                        <p-progressSpinner></p-progressSpinner>
                    </div>
                    <div class="formgrid grid" *ngIf="!loadingSpinnerDialog && itemServico">
                        <div class="field col-12 sm:col-6">
                            <label class="label-superior text-lg">Custo Fixo</label>
                            <label class="label-inferior">
                                {{ custoMedio.custoFixo / 100 | percent: "1.2-2" }}
                            </label>
                        </div>
                        <div class="field col-12 sm:col-6">
                            <label class="label-superior text-lg">Custo Tributário</label>
                            <label class="label-inferior">
                                {{ custoMedio.imposto / 100 | percent: "1.2-2" }}
                            </label>
                        </div>
                        <div class="field col-12 sm:col-6">
                            <label class="label-superior text-lg">Custo Material</label>
                            <label class="label-inferior">
                                {{
                                    itemServico.custoMaterial
                                        ? (itemServico.custoMaterial / 100 | percent: "1.2-2")
                                        : "0,00%"
                                }}
                            </label>
                        </div>
                        <div class="field col-12 sm:col-6">
                            <label class="label-superior text-lg">Comissão</label>
                            <label class="label-inferior">
                                {{
                                    itemServico.comissaoVenda
                                        ? (itemServico.comissaoVenda / 100 | percent: "1.2-2")
                                        : "0,00%"
                                }}
                            </label>
                        </div>
                        <div class="field col-12 sm:col-6">
                            <label class="label-superior text-lg">Valor Serviço</label>
                            <label class="label-inferior">
                                {{ itemServico.valorVenda | currency: "BRL" }}
                            </label>
                        </div>
                        <div class="field col-12 sm:col-6">
                            <label class="label-superior text-lg">Lucro Atual</label>
                            <label class="label-inferior">
                                {{ valorLucroObtidoAtual | currency: "BRL" }} |
                                {{
                                    ((valorLucroObtidoAtual / (itemServico.valorVenda ?? 0)) *
                                        100) /
                                        100 | percent: "1.2-2"
                                }}
                            </label>
                        </div>
                        <div style="width: 100%">
                            <p-divider></p-divider>
                        </div>
                        <div class="field col-12 sm:col-6">
                            <label class="text-lg">Lucro Desejado</label>
                            <p-inputNumber
                                name="valorLucroDesejado"
                                ngModel
                                mode="currency"
                                currency="BRL"
                                locale="pt-BR"
                                [allowEmpty]="true"
                                [required]="true"
                                [(ngModel)]="valorLucroDesejado"
                                (onInput)="calcularLucroDesejado($event)"
                            ></p-inputNumber>
                        </div>
                        <div class="field col-12 sm:col-6">
                            <label class="text-lg">Novo valor Serviço</label>
                            <p-inputNumber
                                name="novoValorServico"
                                ngModel
                                mode="currency"
                                currency="BRL"
                                locale="pt-BR"
                                [allowEmpty]="true"
                                [required]="true"
                                [(ngModel)]="novoValorServico"
                                (onInput)="calcularLucroObtido($event.value)"
                            ></p-inputNumber>
                        </div>

                        <div class="field col-12 sm:col-6">
                            <label class="label-superior text-lg">Valor Sugerido</label>
                            <label class="label-inferior">
                                {{ valorSugerido | currency: "BRL" }}
                            </label>
                        </div>
                        <div class="field col-12 sm:col-6">
                            <label class="label-superior text-lg">Lucro Obtido</label>
                            <label class="label-inferior" *ngIf="novoValorServico > 0">
                                <span
                                    class="product-badge bg-green-600 admihair-text-white"
                                    *ngIf="valorLucroObtido >= valorLucroDesejado"
                                >
                                    {{ valorLucroObtido | currency: "BRL" }}
                                </span>
                                <span
                                    class="product-badge bg-red-600 admihair-text-white"
                                    *ngIf="valorLucroObtido < valorLucroDesejado"
                                >
                                    {{ valorLucroObtido | currency: "BRL" }}
                                </span>
                            </label>
                            <label class="label-inferior" *ngIf="novoValorServico <= 0">
                                {{ valorLucroObtido | currency: "BRL" }}
                            </label>
                        </div>
                    </div>
                </ng-template>
            </p-dialog>
        </div>
    </div>
</div>
